export default "__VITE_ASSET__BEz1aSMl__"